import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Buttonh,
  Img,
  Imgg,
  ButtoCon
} from './InfoSection.elements';
// import { ContactForm } from '../Contact';
// import {Slider  } from '../Slider';
import { GrElevator, GrEscalator, GrConfigure } from 'react-icons/gr';
import { IconContext } from 'react-icons/lib';
// import {  Row, Col, Container } from 'react-modal'


import {
ButtonActionContainer,
ButtonAction,
  PricingSection,
  PricingWrapper,

  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from '../Pricing/Pricing.elements';
import story from '../../images/story.png';
import vision from '../../images/vision.png';
import mission from '../../images/mission.png';

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin,
  FaWhatsapp,
  FaPhoneAlt,
  
} from 'react-icons/fa';
import ReactPlayer from 'react-player';
import {
  MdWork,
  
} from 'react-icons/md';
import {
  IoIosPin,
  
} from 'react-icons/io';
import rr from '../../images/rr.jpeg';

import {
  CardWrapper,
  SocialLink,
  CardHeader,
  AddressContainer,
  CardHeading,
  CardBody,
  CardIcon,
  CardFieldset,
  CardInput,
  CardOptionsItem,
  CardOptions,
  CardOptionsNote,
  AddressWrapper,
  EmailContainer,
EmailIcon,
AddressIcon,
  CardButton,
  CardLink,
  MapWrapper,
  ContactSection,
  SocialContainer,
  MapContainer,
  ContactWrapper,
  ContactText,
  ContactgHeading,
ContactContainer,
googlemapcode,
IFrame,
EmaiWrapper,
SocialIconLink,
SocialWrapper
} from '../Contact/Contact.elements';
import Projects from '../projects/projects'
import { FaCaretUp } from 'react-icons/fa'
function Home({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  bglight,
  alt,
  imgStart,
  start,
  boxsh
}) {
  return (
    <>
     <Imgg  src= { rr } />
      <InfoSec style={{ textAlign:'center'}}  lightBg={true} boxsh={false} >
        <Container>
                <Heading style={{ marginRight:'50px'  }} lightText={true}>الهدف الرئيسي من المبادرة
</Heading>
                
                <Heading  style={{ color:'#909284', fontSize:'20px',  }}lightTextDesc={true}>
                دمج اصحاب الهمم "السمعية – البصرية – الحركية " من طلاب
الجامعات المصرية وخاصة جامعة القاهرة داخل المجتمع و سوق العمل
والتركيز عليهم كفئة أساسية من فئات المجتمع</Heading>
{/* <ButtoCon to='/aboutus' >
          <Buttonh  primary >Learn more</Buttonh>
          </ButtoCon> */}
     

                       </Container>
                        <Container>
                <Heading style={{ marginRight:'50px'  }} lightText={true}>الفكرة الخاصة بالمبادرة
                
</Heading>
                
                <Heading  style={{ color:'#909284', fontSize:'20px',  }}lightTextDesc={true}>إنطلاقا من رؤية مصر  2030لدعم وتمكين
ذوي الاحتياجات الخاصة وتذليل كل
الصعوبات التي تواجههم في حياتهم الدراسية
والعملية وكذلك في طريقة التفاعل
الإجتماعي مع بقية أفراد المجتمع .
من هذا المنطلق نقوم - نحن طلبة كلية
الاعلام - بمبادرة اجتماعية لدمج اصحاب
الهمم "السمعية – البصرية – الحركية "
من طلاب الجامعات وخاصة جامعة القاهرة
داخل المجتمع المصرى من جميع النواحى
وخاصة الناحية التعليمية والمهنية ، وذلك
عن طريق تأهيلهم من الناحية العلمية
والعملية للمساعدة علي دمجهم في سوق
العمل و تغيير سلوك أفراد المجتمع تجاههم
وعدم التعامل معهم كفئة مختلفة .</Heading>
{/* <ButtoCon to='/aboutus' >
          <Buttonh  primary >Learn more</Buttonh>
          </ButtoCon> */}
      <Heading style={{ marginRight:'50px'  }} lightText={true}>الجمهور المستهدف

</Heading>
                
                <Heading  style={{ color:'#909284', fontSize:'20px',  }}lightTextDesc={true}>
 ذوي الهمم من طلبة الجامعات "كمرحلة اولى " وخاصة جامعة القاهرة
<br />
 الجمهور العام (جميع فئات المجتمع) وينقسم إلي
<br />
 اسرالطلبة من ذوى الهمم
<br />
 اصحاب مراكز التأهيل
<br />
 باقي فئات المجتمع</Heading>

                       </Container>
      </InfoSec>


 <IconContext.Provider value={{ color: '#eb594c', size: 80 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>خـدماتنــا</PricingHeading>
          <PricingContainer >
            <PricingCard style={{ height:'250px'}} to='/elevators'>
              <PricingCardInfo>
                              <PricingCardPlan>
                              يتم فيه إطلاق المبادرة والحملة الإجتماعية وتكريم عدد من
الرواد من ذوي الهمم وتسليط الضوء عليهم</PricingCardPlan>

                {/* <PricingCardIcon>
                  <GrElevator />
                </PricingCardIcon> */}
                {/* <PricingCardCost>$99.99</PricingCardCost> */}
                {/* <PricingCardLength>per month</PricingCardLength> */}
                <PricingCardFeatures>

                  {/* <PricingCardFeature>$10,000 Budget</PricingCardFeature>
                  <PricingCardFeature>Retargeting analytics</PricingCardFeature> */}
                </PricingCardFeatures>

              </PricingCardInfo>
            </PricingCard>
            <PricingCard style={{ height:'250px'}} to='/escalators'>
              <PricingCardInfo>
                              <PricingCardPlan>كورسات تدريبية خاصة للطلاب من ذوي القدرات الخاصة وتأهيلهم لسوق
العمل من امثلة تلك الكورسات أول كورس مونتاج لذوي القدرات الخاصة
داخل كلية الإعلام جامعة القاهرة .</PricingCardPlan>

                {/* <PricingCardIcon>
                  <GrEscalator />
                </PricingCardIcon> */}
                {/* <PricingCardCost>$299.99</PricingCardCost> */}
                {/* <PricingCardLength>per month</PricingCardLength> */}
                <PricingCardFeatures>
                  {/* <PricingCardFeature>$50,000 Budget</PricingCardFeature>
                  <PricingCardFeature>Lead Gen Analytics</PricingCardFeature> */}
                </PricingCardFeatures>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard style={{ height:'250px'}} to='/maintainance'>
              <PricingCardInfo>
                              <PricingCardPlan>ورش عمل للاعمال اليدوية ومحاولة خلق فرص عمل لهم تتناسب مع
احتياجاتهم </PricingCardPlan>

                {/* <PricingCardIcon>
                  <GrConfigure />
                </PricingCardIcon> */}
                {/* <PricingCardCost>$999.99</PricingCardCost> */}
                {/* <PricingCardLength>per month</PricingCardLength> */}
                <PricingCardFeatures>
              
                  {/* <PricingCardFeature>Unlimited Budget</PricingCardFeature>
                  <PricingCardFeature>24/7 Support</PricingCardFeature> */}
                </PricingCardFeatures>
              </PricingCardInfo>
            </PricingCard>
            
          </PricingContainer>
          {/* <ButtoCon to='/productsandservices' >
          <Buttonh  primary >Explore</Buttonh>
          </ButtoCon> */}
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
   <Projects />


   <ReactPlayer width= '1519px' height='650px' controls url='https://vimeo.com/543195732'/>
   <br />
   <br />

   <ReactPlayer width= '1519px' height='650px' controls url='https://vimeo.com/543199147'/>
   <br />
   <br />
   <ReactPlayer width= '1519px' height='650px' controls url='https://vimeo.com/543196846'/>
   <br />
   <br />

   <ReactPlayer width= '1519px' height='650px' controls url='https://vimeo.com/543197508'/>
<ContactSection >
     <ContactgHeading>اتـصــل بنــا</ContactgHeading>


        <ContactContainer>
        <ContactWrapper>
            <SocialIconLink href='/' target='_blank' aria-label='IoIosPin' >
              <IoIosPin style={{marginLeft:'-50px',}}/>
            </SocialIconLink>
                  <ContactText>Address:Cairo,Egypt</ContactText>
      </ContactWrapper>
      <ContactWrapper>
            <SocialIconLink href='/' target='_blank' aria-label='FaWhatsapp'>
              <FaWhatsapp style={{marginLeft:'-50px',}}/>
            </SocialIconLink>
                  <ContactText>Phone number : 01091353211</ContactText>
      </ContactWrapper>       
      </ContactContainer>

<AddressContainer>

     <SocialContainer>
            <SocialLink href='https://www.facebook.com/card10campaign/' target='_blank' aria-label='FaFacebook'>
              <FaFacebook />
            </SocialLink>
            <SocialLink href='https://www.linkedin.com/in/بطاقة-رقم-عشرة-648159201' target='_blank' aria-label='FaLinkedin'>
              <FaLinkedin />
            </SocialLink>
            <SocialLink href='https://youtube.com/channel/UCMZgneMScJGLpN_VQPxdTwA' target='_blank' aria-label='FaYoutube'>
              <FaYoutube />
            </SocialLink>
            <SocialLink href='https://twitter.com/10_campaign?s=11' target='_blank' aria-label='FaTwitter'>
              <FaTwitter />
            </SocialLink>
            <SocialLink href='https://instagram.com/card10campaign?igshid=2t7ic0gwmhc4' target='_blank' aria-label='FaInstagram'>
              <FaInstagram />
            </SocialLink>
      </SocialContainer>

      </AddressContainer>
   
       </ContactSection>
   

   


    </>
  );
}

export default Home;
